/**
 * Returns whether the document is in RTL mode.
 */
export function isDocumentRtl(): boolean {
    return document.documentElement?.getAttribute('dir') === 'rtl';
}

/**
 * Resolves ngbDropdown placement for grid row action menus.
 *
 * Returns an ordered *preference list*, not a single placement: ng-bootstrap splits
 * on whitespace and Popper uses the first entry that actually fits in the viewport.
 * The row hint only decides which side we try first — the fallback is what guarantees
 * the menu can never render off-screen. A single fixed placement cannot flip, so a row
 * sitting low in the viewport (but not in the page's last rows, e.g. with 20 per page
 * in a scrolling grid) would otherwise be clipped at the bottom.
 *
 * Always use logical `end` — ng-bootstrap maps it for RTL (bottom-end → bottom-start).
 */
export function getGridActionDropdownPlacement(
    rowIndex?: number | null,
    totalRows?: number | null
): string {
    const preferUp =
        rowIndex != null &&
        totalRows != null &&
        totalRows > 8 &&
        rowIndex >= totalRows - 2;
    return preferUp ? 'top-end bottom-end' : 'bottom-end top-end';
}
